import { createContext } from 'react';
import { Entity } from '../../../../../@Api/Model/Implementation/Entity';

export default createContext<(entity: Entity) => void>(undefined);